<template>
    <form id="form-search-news" action="" method="GET" @submit.prevent="searchNews">
        <div class="input-group input-search-news bg-white">
            <input type="text"
                v-model.trim="textSearch"
                id="input-search-news" 
                class="form-control" 
                placeholder="Buscar palabra clave">
            <div class="input-group-append">
                <button :disabled="textSearch === '' || formLoading" class="px-3" type="submit" id="button-addon2">
                    <i class="fas fa-search text-white bg-color-palette-2 p-2" style="border-radius: 20px;"></i>
                </button>
            </div>
        </div>
    </form>
</template>

<script>
    export default {
        name: "InputSearchNews",
        components: {
        },
        data() {
            return {
                textSearch: '',
                formLoading: false,
                csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
            }
        },
        methods: {
            searchNews() {
                this.formLoading = true
                const rutaForm = `${window.BASE_URL}/blog?text=${this.textSearch}`
                window.location = rutaForm
            }
        }
    }
</script>

<style>
#input-search-news {
    height: 3rem;
    border-radius: 40px;
    border: 0;
    z-index: 10;
}

#input-search-news:focus {
    box-shadow: none;
}

#button-addon2:disabled i {
    opacity: 0.6;
}

#button-addon2:disabled:hover i {
    opacity: 0.6;
}

#button-addon2:hover i {
    opacity: 0.9;
    transition: 0.3s;
}
</style>